module.exports = "pegasus/assets/blocks/column-5-tech.png";